export enum DashboardWidgetType {
  RESPONSE_MANAGER = 0,
  DOUGHNUT = 1,
  RESPONSE_RATE_LEGACY = 2,
  STACKED_BAR = 3,
  TABLE = 4,
  TEXT = 5,
  BUBBLE = 6,
  SCATTER = 7,
  SECTION = 8,
  BAR_TABLE = 9,
  OPEN_COMMENTS = 10,
  TAG_CLOUD = 11,
  INSIGHT_WHEEL = 12,
  TREND_ANALYSIS = 13,
  DETAILED_ORG_UNIT_RESPONSE_RATE = 14,
  ORG_UNIT_RESPONSE_RATE = 15,
  RESPONSE_FUNNEL = 16,
  SPEEDOMETER = 17,
  COMPARISON_OF_UNITS = 18,
  NPS_DISTRIBUTION = 19,
  NPS_SCORE_GAUGE = 20,
  REASONS_FOR_LEAVING = 21,
  RESPONSE_RATE = 22,
  QUESTION = 23,
  AVERAGE_RESOLUTION_TIME = 24,
  DETRACTOR_TICKETS = 25,
  ROOT_CAUSES = 26,
  TOTAL_TICKETS = 27,
  DEEP_DIVE_QUESTIONS = 28,
  SPEEDOMETER_RE = 29,
  GENERIC_TREND_ANALYSIS = 30,
  OPEN_COMMENTS_WIDGET_ENDPOINT = 31,
  MYFOLLOWUP_STATE = 33,
  MYFOLLOWUP_SURVEY_OVERVIEW = 34,
  BAR_DIAGRAM = 35,
  COMPARISON_OF_DEMOGRAPHICS = 36,
  NPS_TREND_ANALYSIS = 37,
  TREND_ANALYSIS_RESPONSE_RATE = 38,
  FLEXIBLE_CHART = 39,
}

export enum DashboardWidgetComparisonType {
  ANCESTOR = 1,
  CHILDREN = 2,
}
